import { sendPost } from "src/utils/sendApi";

export const fetchExperiment = sendPost("v1/data/_experiment");

export const fetchSimilarExperiment = sendPost("v1/data/_similar_formulations");

export const editDisplayId = sendPost("v1/data/_form_meta_update");

export const fetchSimilarFormulations = sendPost("v1/data/group-similar-formulations")
